/* eslint-disable camelcase */
import { isNumber, isObject, isString, isArray } from 'typechecker'

export type CitySuggestionArgument = {
  name?: string
  location?: string
  lat?: number
  lng?: number
  maxDistance?: number
  country?: string
  collections?: string[]
  storeInventories?: StoreInventory[]
  comments?: Comment[]
  overviews?: Overview[]
}

type BlogPost = {
  title: string
  link: string
  img: string
}

type StoreInventory = {
  storeName: string
  storeId: number
  count: number
}

type Comment = {
  store_comment: string
  store_score_all: number
  name: string
  brand: string
}

type Overview = {
  title: string
  content: string
}

export default class CitySuggestion {
  /** 地區名稱 */
  name?: string

  /** 地區 */
  location?: string

  /** 緯度 */
  lat?: number

  /** 經度 */
  lng?: number

  /** 最大搜尋距離 */
  maxDistance?: number

  /** 國家 */
  country?: string

  /** 車款 */
  collections: string[] = []

  /** 店家即時庫存 */
  storeInventories: StoreInventory[] = []

  /** 評論 */
  comments: Comment[] = []

  /** 租車攻略 */
  overviews: Overview[] = []

  constructor (suggestion: CitySuggestionArgument) {
    if (!isObject(suggestion)) throw new TypeError('`suggestion` must be an object!')

    if (isString(suggestion.name)) this.name = suggestion.name
    if (isString(suggestion.location)) this.location = suggestion.location
    if (isNumber(suggestion.lat)) this.lat = suggestion.lat
    if (isNumber(suggestion.lng)) this.lng = suggestion.lng
    if (isNumber(suggestion.maxDistance)) this.maxDistance = suggestion.maxDistance
    if (isString(suggestion.country)) this.country = suggestion.country
    if (suggestion.collections && isArray(suggestion.collections)) this.collections = suggestion.collections
    if (suggestion.storeInventories && isArray(suggestion.storeInventories)) this.storeInventories = suggestion.storeInventories
    if (suggestion.comments && isArray(suggestion.comments)) this.comments = suggestion.comments
    if (suggestion.overviews && isArray(suggestion.overviews)) this.overviews = suggestion.overviews
  }
}
